<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->

    <!-- 电脑导航 -->
    <div class="header-nav container hidden-sm hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_black.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item['name'+type])"
        >
          <router-link :to="item.path">
            {{item['name'+type]}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <!-- <router-link :to="i.path" tag="a">{{i.name}}</router-link> -->
              <div @click="gotoPage(i)">
                {{i['name'+type]}}
                <i class="underline"></i>
              </div>
            </dt>
          </dl>
        </li>
        <li class="zh-en" @click="updateShow">
              <img src="../assets/img/zh-en.png" alt="中英转换">
        </li>
      </ul>

    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-sm visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center"
      data-toggle="collapse"
      data-target="#menu"
      @click="menuClick"
      >
        {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item['name'+type])"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path" tag="a">
              {{item['name'+type]}}
              <i class="underline"></i>
            </router-link>
             <dl v-if="item.children.length>0">
               <dt v-for="(i,n) in item.children" :key="n">
                 <!-- <router-link :to="i.path" tag="a">{{i.name}}</router-link> -->
                 <div @click="gotoPage(i)">
                   {{i['name'+type]}}
                   <i class="underline"></i>
                 </div>
               </dt>
             </dl>
            <div class="open-list" v-if="item.children.length>0">
              <i class="glyphicon glyphicon-menu-down"></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      type:'',
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          nameEn:"Home",
          path: "/",
          children: []
        },
        {
          name: "关于我们",
          nameEn:"About Us",
          path: "/software",
          meta:{
            point:"company"
          },
          children: [
            {
              name: "公司介绍",
              nameEn:"About Us",
              path: "/software/smartTown",
              meta:{
                point:"company"
              }
            },
            {
              name: "企业文化",
              nameEn:"Corporate Culture",
              path: "/software/smartTown",

              meta:{
                point:"culture"
              }
            },
            {
              name: "服务理念",
              nameEn:"Service Concept",
              path: "/software/smartTown",
              meta:{
                point:"linian"
              }
            }
          ]
        },
        {
          name: "服务项目",
          nameEn:"Service",
          path: "/LogisticsService",
          meta:{
            point:"a"
          },
          children: [
            {
              name: "国际空运",
              nameEn:"International Air Transport",
              path: "/LogisticsService",
              meta:{
                point:"a"
              }
            },
            {
              name: "国际海运",
              nameEn:"International Shipping",
              path: "/LogisticsService",
              meta:{
                point:"b"
              }
            },
            {
              name: "国际铁路",
              nameEn:"International Railway Transport",
              path: "/LogisticsService",
              meta:{
                point:"c"
              }
            },
            {
              name: "国际快递",
              nameEn:"International Express Service",
              path: "/LogisticsService",
              meta:{
                point:"d"
              }
            },
            {
              name: "俄罗斯清关",
              nameEn:"Russian Customs Clearance Service",
              path: "/LogisticsService",
              meta:{
                point:"e"
              }
            },
            {
              name: "物流定制方案",
              nameEn:"Customized Solution of Logistics",
              path: "/LogisticsService",
              meta:{
                point:"f"
              }
            },
          ]
        },
        // {
        //   name: "新闻动态",
        //   nameEn:"News",
        //   path: "/newsinformation",
        //   children: []
        // },

        {
          name: "我们的优势",
          nameEn:"Our Advantages",
          path: "/advantage",
          children: []
        },
        {
          name: "联系我们",
          nameEn:"Contact Us",
          path: "/contactus",
          children: []
        }
      ],
    };
  },
  created() {
    this.type=this.$store.getters.getShowEn?'En':'';
    this.menuName=this.$store.getters.getShowEn?'Home':'首页';
  },
  watch:{
    '$store.state.showEn':function(newVal){
      let newMenuName=this.navList.find(item=>item['name'+this.type]==this.menuName)
      if(newVal){
        this.type='En'
      }else{
        this.type=''
      }
      this.menuName=newMenuName['name'+this.type];
    }
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    gotoPage(item){
      this.$router.push({
        path:item.path,
        query:{
          point:item.meta.point
        }
      })
      this.$nextTick(()=>{
        let ele=document.getElementById(item.meta.point);
        ele.scrollIntoView(true);
      })
    },
    updateShow(){
      this.$store.commit('updateShowEn',!this.$store.getters.getShowEn)
    },
  }
};
</script>
<style scoped>
/* 自增样式  */
.zh-en{
  line-height: 110px;
  text-align: center;
  cursor: pointer;
}
.zh-en img{
  display: inline;
  width: 25px;
  height: 25px;
  font-size: 0;
}
/* 顶部 */
/* #header {
  background: white;
  transition: all ease 0.6s;
} */
#header .header-nav .header-nav-logo {
  width: 360px;
  height: 100%;
  float: left;
  position: relative;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 300px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width:100%;
  height:auto;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 900px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 15px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 200px;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: black;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: white;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: black;
    z-index: 99999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: white;
    z-index: 999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: auto;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
    position: relative;
  }
    #header .header-nav-m .header-nav-m-wrapper > li .open-list{
      position: absolute;
      top: 0;
      right: 3.125rem;
      line-height: 40px;
    }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: black;
    font-size: 18px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue